import PropTypes from "prop-types";
import { Typography } from "core/typography/Typography";
import { FormattedMessage } from "react-intl";
import Button from "core/buttons/button/Button";

const SixYearReview = ({
  consultantBySlug,
  consultantSixYearsReview,
  downloadReviewFile,
}) => {
  const reviewYear = (created_at) => new Date(created_at).getFullYear();

  return (
    <div className="section-n">
      <Typography
        className="title-3 violet text-uppercase"
        type="h2"
        label={
          <FormattedMessage
            id="six_year_review_title"
            defaultMessage="Résumé bilans professionnels du salarié"
          />
        }
      />
      <div className="training-section">
        {consultantSixYearsReview?.map((review, index) => (
          <Button
            key={`${review.id}-${index}`}
            className="btn-standard btn-outline"
            type="button"
            onClick={() =>
              downloadReviewFile({
                id: review.docx_id,
                fileName: `${consultantBySlug?.first_name}_${consultantBySlug?.last_name}_Bilans_${reviewYear(review.created_at)}.docx`,
              })
            }
          >
            {reviewYear(review.created_at)}
          </Button>
        ))}
      </div>
    </div>
  );
};

SixYearReview.propTypes = {
  consultantBySlug: PropTypes.object,
  consultantSixYearsReview: PropTypes.array,
  downloadReviewFile: PropTypes.func,
};

export default SixYearReview;
